import { DateFormat, DateTimeFormat } from "@/modules/localization/formatter";
import { KTIcon } from "_metronic/helpers"
import clsx from "clsx";
import { FC } from "react"
interface DataGridWrapperProps {
    height?: string,
    timelines: any
}

const iconChooser = (statusCode: any): any => {
    switch (statusCode) {
        case "Requested":
            return "message-question";
        case "Awaiting Approval":
            return "watch";
        case "Approved":
            return "check";
        case "Rejected":
            return "cross";
        default:
            return "watch";
    }

}

const colorChooser = (statusCode: any): any => {
    switch (statusCode) {
        case "Requested":
            return "fs-2 text-primary";
        case "Awaiting Approval":
            return "fs-2 text-info";
        case "Approved":
            return "fs-2 text-success";
        case "Rejected":
            return "fs-2 text-danger";
        default:
            return "fs-2 text-primary";
    }

}

const ApprovalRequestTimeline: FC<DataGridWrapperProps> = ({ timelines, height='250px' }) => (
    <div
        id='kt_activities'
        className='bg-white'
        data-kt-drawer='false'
        data-kt-drawer-name='activities'
        data-kt-drawer-activate='false'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_activities_toggle'
        data-kt-drawer-close='#kt_activities_close'
    >
        <div className='card shadow-none rounded-0'>
            <div className='card-body position-relative' id='kt_activities_body'>
                <div
                    id='kt_activities_scroll'
                    className='position-relative scroll-y me-n5 pe-5'
                    data-kt-scroll='true'
                    data-kt-scroll-height='auto'
                    data-kt-scroll-wrappers='#kt_activities_body'
                    data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
                    data-kt-scroll-offset='5px'
                    style={{ minHeight:'200px', maxHeight: height, overflowY: "auto" }}
                >
                    <div className='timeline'>
                        {timelines.map((timeline: any, index: number) => {
                            return (
                                <div className='timeline-item'>
                                    <div className='timeline-line w-40px'></div>

                                    <div className='timeline-icon symbol symbol-circle symbol-40px'>
                                        <div className='symbol-label bg-light'>

                                            <KTIcon iconName={iconChooser(timeline.statusCode)} className={colorChooser(timeline.statusCode)} />
                                        </div>
                                    </div>

                                    <div className='timeline-content mt-n1'>
                                        <div className='pe-3'>
                                            <div className='fs-5 fw-semibold'>
                                                {timeline.status}
                                            </div>

                                        </div>
                                        <div className='d-flex align-items-center  fs-6'>
                                            <div className='text-muted me-2 fs-7'>{timeline.decisionDate && (DateFormat(new Date(timeline.decisionDate + "Z")) + ' ' + DateTimeFormat(new Date(timeline.decisionDate + "Z")))} - </div>

                                            <span className='text-primary fw-bold me-1'>
                                                {timeline.approver}
                                            </span>
                                        </div>

                                        
                                        {timeline.comment && (<div
                                                className={clsx(
                                                    'p-5 rounded',
                                                    'bg-light-info',
                                                    'fs-7 fw-italic mw-lg-400px',
                                                    `text-'start'}`
                                                )}
                                                data-kt-element='message-text'
                                                dangerouslySetInnerHTML={{ __html: timeline.comment}}
                                            ></div>)}
                                    </div>
                                </div>
                            )
                        })}


                    </div>
                </div>
            </div>
        </div>
    </div>
)

export { ApprovalRequestTimeline }